import WorkerApiService from "../../workerApiServices";

class ProvisaoRecebimentoService extends WorkerApiService {

    constructor() {
        super('/api/provisaoRecebimento')
    }

    save(object){
        return this.post("/save", object)
    }

    edit(object){
        return this.put("/edit", object)
    }

    deleteById(id){
        return this.delete(`/delete/${id}`)
    }

    jaExisteTipoDeRecebimentoAndNumeroDocumento(object){
        return this.post("/jaExisteTipoDeRecebimentoAndNumeroDocumento", object)
    }

    searchById(id){
        let params = `?`
        params = `${params}&id=${id}`
        return this.get(`/searchById${params}`)
    }

}

export default ProvisaoRecebimentoService
